var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function fn() {
        return [_c('sub-visual', {
          attrs: {
            "sh": "Product",
            "tabActive": "Fleece & Sherpa Line",
            "bg": "/images/sub/visual/sv-product.jpg"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('sub-section', {
    staticClass: "page-section--first page-section--last"
  }, [_c('sub-product', {
    attrs: {
      "tit": "Fleece & Sherpa Line",
      "file": "fleece"
    }
  }, [_vm._v(" Sherpa with short/long pile, Polar fleece, Mink Fleece, Terry Fleece, Velour, Brushed Knit, etc. We have a lot of experience with synthetic blend sherpa and fleece fabrics. Also have special strengths of price and quality. ")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }